import { render, staticRenderFns } from "./CompletedSubtaskModal.vue?vue&type=template&id=361fcca6"
import script from "./CompletedSubtaskModal.vue?vue&type=script&lang=js"
export * from "./CompletedSubtaskModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports